import { render, staticRenderFns } from "./totalizer.vue?vue&type=template&id=143a55a6&scoped=true&"
import script from "./totalizer.vue?vue&type=script&lang=js&"
export * from "./totalizer.vue?vue&type=script&lang=js&"
import style0 from "./totalizer.vue?vue&type=style&index=0&id=143a55a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143a55a6",
  null
  
)

export default component.exports